import React from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import Authorities from "../../../auth/authorities";
import { getIsAuthorized } from "../../../utils/authorities";
import ListAltIcon from "@material-ui/icons/ListAlt";
import Location from "../../PrestoExpressLocationApp/pages/Location";
import DashboardIcon from "@material-ui/icons/Dashboard";
import AlertConfig from "../pages/AlertConfig";
import AvailabilityPage from "../pages/AvailabilityPage";
import MetricsListPageNewNew from "../pages/MetricsListPageNewNew";
import MetricsListShowPageNew from "../pages/MetricsListShowPageNew";
import SettingPage from "../pages/SettingPage";
import { Icon } from "@iconify/react";

export const getSidebarRoutes = () => {
  const sidebarRoute = [
    {
      id: "Dashboard",
      title: "Dashboards",
      path: "/dashboard",
      icon: <DashboardIcon />,
      isAuthorized: getIsAuthorized(Authorities.TASKS_READ),
    },
    {
      id: "Alert Config",
      title: "Alert Configuration",
      path: "/alertConfig",
      icon: <DashboardIcon />,
      isAuthorized: getIsAuthorized(Authorities.TASKS_READ),
    },
    {
      id: "Availability",
      title: "Availability",
      path: "/availability",
      icon: <DashboardIcon />,
      isAuthorized: getIsAuthorized(Authorities.TASKS_READ),
    },
    {
      id: "internal",
      title: "Internal Configurations",
      path: "/internalConfiguration",
      icon: <Icon icon="ri:admin-line" height="24" width="24" />,
      isAuthorized: getIsAuthorized(Authorities.PAYMENT_CONFIGURATION_READ),
      childRoutes: [
        {
          id: "resetConfiguration",
          title: "Reset Configuration",
          path: "/internalConfiguration/resetConfiguration",
          icon: <Icon icon="dashicons:admin-generic" height="24" width="24" />,
          isAuthorized: getIsAuthorized(Authorities.PAYMENT_CONFIGURATION_READ),
        },
      ],
    },
  ];
  return sidebarRoute;
};
export interface InsightAppRoutesProps {}

const InsightAppRoutes: React.FunctionComponent<InsightAppRoutesProps> = () => {
  const location = useLocation();

  return (
    <Switch>
      <Route
        path="/:locationId/presto-insight/dashboard"
        component={MetricsListPageNewNew}
        exact
      />
      <Route
        path="/:locationId/presto-insight/alertConfig"
        component={AlertConfig}
        exact
      />
      <Route
        path="/:locationId/presto-insight/availability"
        component={AvailabilityPage}
        exact
      />
      <Route
        path="/:locationId/presto-insight/internalConfiguration/resetConfiguration"
        component={SettingPage}
        exact
      />

      <Route
        path="/:locationId/presto-insight/public/:layoutId"
        component={MetricsListShowPageNew}
        exact
      />
      <Route path="/" component={Location} exact />
    </Switch>
  );
};

export default InsightAppRoutes;
